import React from 'react';
import { connect } from 'redux-bundler-react';
import xhr from 'xhr';

import DisplayLibrary from './display-library';
import DisplayLayer from './display-layer';
import LayerServicePortal from './service-info/service-portal';
import LayerServiceQGIS from './service-info/service-qgis';

const mmcHost = process.env.REACT_APP_MMC_ENV;

class DatasetInfo extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      content: 'Fetching Information',
    }
    
    this.close = this.close.bind(this);
    this.renderAsync = this.renderAsync.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.renderResponse = this.renderResponse.bind(this);
    this.renderServices = this.renderServices.bind(this);
  }

  componentDidMount(){
    const { item, type } = this.props;
    if(!type && item.info){
      if(item.info.url) return this.renderAsync();
    }else if(type==='serviceInfo') {
      return this.renderServices()
    }
  }

  close() {
    const { doCloseModalWindow } = this.props;
    doCloseModalWindow();
  }

  renderResponse(data){
    let content = null
    if(data.type === 'library') {
      content = (<DisplayLibrary data={data}/>)
    }else if(data.type === 'layer') {
      content = (<DisplayLayer data={data} layerInfo={this.props.item}/>)
    }else{
      content = null;
    }

    this.setState({content: content})
  }
  renderServices(){
    const { item, serviceType } = this.props;
    let content;
    if(serviceType==='portal') {
      content=(<LayerServicePortal layerInfo={item}/>)
    }else if(serviceType==='qgis') {
      content=(<LayerServiceQGIS layerInfo={item}/>)
    }
    this.setState({content: content})

  }
  renderContent(){
    const { item } = this.props;
    const { content } = item.info;
    return this.renderResponse(content);
  }

  renderAsync(){
    const { item } = this.props;
    let url = item.info.url;
    if(item.type==='Folder') {      
      url = `${mmcHost}${url}`
    }
    xhr.get(url, (err, response, body) => {
      if(err){
        this.setState({content: 'Error Loading Content'})
      }else if(response.statusCode !==200){
        this.setState({content: 'Error Loading Content'})
      }else{
        const data = JSON.parse(body);
        this.renderResponse(data);
      }
    })
  }

  render(){
    const { content } = this.state;
    const { theme, item, type } = this.props;
    let title ='Metadata';
    if(type==='serviceInfo') {
      title='Service Info'
    }
    return (
      <div>
        <div className={"modal-header " + theme}>
          { item.displayName || item.NAME } {title}
        </div>
        <div
          className="modal-body thin-scrollbar"
          style={{ height: (window.innerHeight * 0.75), top: 0, bottom: 0, left: 0, right: 0, overflow: 'auto'}}
          
        >
          {content}
        </div>
        <div className="modal-footer">
          <button className={"btn btn-theme " + theme} onClick={this.close}>
            Close
          </button>
        </div>
      </div>
    )
  }
}

export default connect(
  'selectTheme',
  'doCloseModalWindow',
  DatasetInfo
);